import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductService } from 'src/app/services/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { VolumetricValidation, regexPattern } from 'src/app/models/validator';
import { AppCoreService } from 'src/app/services/app-core.service';
import * as $ from 'jquery';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Title } from '@angular/platform-browser';
import { Utilities } from 'src/app/models/utilities';
import { ExcelService } from 'src/app/services/excel.service';
import { ColDef, ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ReportService } from 'src/app/services/report/report.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/services/customer.service';
import { NetworkService } from 'src/app/services/network.service';
import { CompanyService } from 'src/app/services/company.service';
import { VendorService } from 'src/app/services/vendor.service';
import { GeoService } from 'src/app/services/geo.service';

interface ExtendedColDef extends ColDef {
  visible?: boolean;
}

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewReportNewComponent implements OnInit {
  reportNewForm: FormGroup;
  reportForm: FormGroup;
  countryForm: FormGroup;
  scheduleForm: FormGroup;
  frequencyOptions = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' }
  ];
  targetOptions = [
    { label: 'Customer', value: 'Customer' },
    { label: 'Aggregated', value: 'Aggregated' }
  ];
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted = false;
  reportId: number;
  rowData = [];
  fields: any = [];
  reportname: string;
  reportData: any;
  isShowCustomReportName = false;
  isdisabled = false;
  vendorList: any[];
  title: any = "Report";
  originCityList: any[] = [];
  destinationCityList: any[] = [];
  countryCode: any;
  countryList: any[] = [];
  destinationStateList: any[] = [];
  originStateList: any[] = [];
  customerList: any[] = [];
  defaultCustomer: any;
  serviceCenterList: any[] = [];
  productList: any[] = [];
  productTypeList = ['Domestic', 'International', 'Import'];
  columnDefs: ExtendedColDef[] = [];
  userType: any;
  companyList: any[] = [];
  selectedSCId: number;
  customReportName: string;
  paymentTypeList = ['Credit', 'Cash', 'COD'];
  businessTypeList = ['B2B', 'B2C'];
  misReportType = [{ name: 'All', value: '' }, { name: 'Delivered', value: 'SHIPMENT_DELIVERED' }, { name: 'Un Delivered', value: 'SHIPMENT_UNDELIVERED' },
  { name: 'Pending', value: 'Pending' }, { name: 'RTO', value: 'SHIPMENT_RETURNED' }];
  deliveryReportStatus = [{ name: 'All', value: '' }, { name: 'Delivered', value: 'SHIPMENT_DELIVERED' }, { name: 'Un Delivered', value: 'SHIPMENT_UNDELIVERED' }];

  lockType = [{ name: 'All', value: '' }, { name: 'Lock', value: true }, { name: 'Un Lock', value: 'false' }];
  customerTypeList = ['Customer', 'Co-Courier', 'Franchisee'];
  schdulerId: number;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight',
  }

  groupedData: any[] = [];
  isGrouped: boolean = false;
  groupedColumns: string[] = [];
  currentGroup: string = null;
  reservedRowData = [];
  isModalOpen = false;

  constructor(
    private toastr: ToastrService,
    private appCoreService: AppCoreService,
    private productService: ProductService,
    private router: Router,
    private route: ActivatedRoute,
    private ngxLoaderService: NgxUiLoaderService,
    private titleService: Title,
    private utilities: Utilities,
    private excelService: ExcelService,
    private reportService: ReportService,
    private fb: FormBuilder,
    private ngxLoadService: NgxUiLoaderService,
    private customerService: CustomerService,
    private networkService: NetworkService,
    private companyService: CompanyService,
    private vendorService: VendorService,
    public modalService: NgbModal,
    public geoService: GeoService

  ) {
    titleService.setTitle('Report');
  }

  ngOnInit() {
    this.reportNewForm = this.fb.group({
      txtReportName: [null, Validators.required]
    });
    this.reportForm = this.fb.group({});

    this.countryForm = this.fb.group({
      ddlOriginCountry: [null],
      ddlOriginState: [null],
      ddlOriginCity: [null],
      ddlDestinationCountry: [null],
      ddlDestinationState: [null],
      ddlDestinationCity: [null],
    })

    this.scheduleForm = this.fb.group({
      frequency: [null, Validators.required],
      emailIds: [null, [Validators.pattern(/^([\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4})(,\s*[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4})*$/)]],
      active: [true],
      targetType: ['Aggregated', Validators.required]
    });

    this.reportId = this.route.snapshot.params['id'];

    this.handelEvent(null);
    const firstInput = $(':input').first();
    if (firstInput) {
      firstInput.focus();
    }

    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.bindVendor();
      this.getServiceCenters();
      this.bindProducts();
      this.bindCompanies();
      this.bindCountries();
    }

    // this.scheduleForm.get('targetType').valueChanges.subscribe((value) => {
    //   console.log('targetType', value);
    //   if(value){
    //     if (value === 'Aggregated') {
    //       this.scheduleForm.get('emailIds').setValidators([Validators.required]);
    //     } else {
    //       this.scheduleForm.get('emailIds').clearValidators();
    //     }
    //     // this.scheduleForm.get('emailIds').reset();
    //     this.scheduleForm.get('emailIds').updateValueAndValidity();
    //   }
    // });
  }

  onTargetChange() {
    let value = this.scheduleForm.get('targetType').value;
    if(value){
      if (value === 'Aggregated') {
        this.scheduleForm.get('emailIds').setValidators([Validators.required]);
      } else {
        this.scheduleForm.get('emailIds').clearValidators();
      }
      // this.scheduleForm.get('emailIds').reset();
      this.scheduleForm.get('emailIds').updateValueAndValidity();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();

    // Add click handler for group rows
    this.gridApi.addEventListener('cellClicked', (event) => {
      if (event.data.isGroup && event.column.getColId() === Object.keys(this.rowData[0])[0]) {
        const group = this.groupedData.find(g => g.groupKey === event.data.groupKey);
        if (group) {
          group.expanded = !group.expanded;
          this.rowData = this.flattenGroupedData(this.groupedData);
          this.gridApi.setRowData(this.rowData);
        }
      }
    });

    // Register the cell renderer through column definitions
    this.columnDefs = this.columnDefs.map(colDef => {
      if (colDef.field === Object.keys(this.rowData[0])[0]) {
        return {
          ...colDef,
          cellRenderer: this.groupCellRenderer.bind(this)
        };
      }
      return colDef;
    });
    this.gridApi.setColumnDefs(this.columnDefs);
  }
  ngAfterViewInit(): void {
    if (this.reportId) {
      this.getReportDetailById(this.reportId);
    }
    //this.useEnterKey ? this.utilities.focusFirstElement(this.productForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Reports');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }

    this.appCoreService.SelectedServiceCenter().subscribe((val) => {
      this.selectedSCId = val;
      //this.bindUsers(val);
      this.bindCustomers(val);
    });
    this.defaultCustomer = userData.metaInfo?.customerid;
    this.userType = userData.accessType;
  }

  handelEvent(e: KeyboardEvent) {
    $(document).ready(function () {

      var inputs = $(':input').keydown(function (e) {
        if (e.key == 'Enter') {
          e.preventDefault();
          var nextInput = inputs.get(inputs.index(this) + 1);
          if (nextInput) {
            nextInput.focus();
          }
        }
      });

    });
  }

  resetForm() {
    this.isFormSubmitted = false;
    //this.productForm.reset();
  }

  getReportDetailById(id) {
    try {

      this.reportService.GetReportById(id).subscribe((res: any) => {
        if (res && res.success) {
          this.reportData = res.data?.reportdata[0];
          if (this.reportData.customreportname) {
            this.isShowCustomReportName = false;
            this.customReportName = this.reportData?.customreportname;
            this.isdisabled = true;
          } else
            this.customReportName = this.reportData.reportname + ' Report';

          this.createForm(res.data?.reportdata);

          /*bind schedule settings*/
          let scheduleConfig = res.data?.scheduledata || null;
          if(scheduleConfig){
            this.schdulerId = scheduleConfig.id;
            this.scheduleForm.get('frequency').setValue(scheduleConfig.schedulefrequency);
            this.scheduleForm.get('active').setValue(scheduleConfig.isactive);
            this.scheduleForm.get('emailIds').setValue(scheduleConfig.schedulemetadata?.emailIds);
            this.scheduleForm.get('targetType').setValue(scheduleConfig.schedulemetadata?.targettype);
          }
        }
      });

    } catch (e) {
      console.error(e);
    }
  }

  createForm(data: any[]) {
    this.fields = data[0].reportconfig;
    this.reportForm = this.fb.group({});
    // this.fields.forEach(field => {
    //   if (field.type === 'date') {
    //     const dateRegex = /^\d{4}-\d{2}-\d{2}$/;      
    //     if (dateRegex.test(field.value)) {
    //       this.reportForm.addControl(field.key, new FormControl(field.value));
    //     } else {
    //       const formattedDate = this.convertToDateFormat(field.value);
    //       this.reportForm.addControl(field.key, new FormControl(formattedDate));
    //     }
    //   } else if (field.type === 'text' || field.type === 'Select') {
    //     this.reportForm.addControl(field.key, new FormControl(field.value));
    //   }
    // });

    this.fields.forEach(field => {

      if (field.hasOwnProperty('key')) {
        if (field.type.toLowerCase() === 'date') {
          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
          if (dateRegex.test(field.value)) {
            this.reportForm.addControl(field.key, new FormControl(field.value));
          } else {
            const formattedDate = this.convertToDateFormat(field.value);
            this.reportForm.addControl(field.key, new FormControl(formattedDate));
          }
        } else if (field.type.toLowerCase() === 'text' || field.type.toLowerCase() === 'select') {
          if (field.type === 'Select') {
            let options = [];
            if (field.key.toLowerCase() === 'product') {
              options = this.productList.map(p => ({
                value: p.id,
                label: p.name
              }));
            } else if (field.key.toLowerCase() === 'customer') {
              options = this.customerList.map(c => ({
                value: c.id,
                label: c.name
              }));
            } else if (field.key.toLowerCase() === 'vendor') {
              options = this.vendorList.map(v => ({
                value: v.id,
                label: v.name
              }));
            } else if (field.key.toLowerCase() === 'company') {
              options = this.companyList.map(c => ({
                value: c.id,
                label: c.name
              }));
            }
            else if (field.key.toLowerCase() === 'producttype') {
              options = this.productTypeList.map(v => ({
                value: v,
                label: v
              }));
            }
            else if (field.key.toLowerCase() === 'paymenttype') {
              options = this.paymentTypeList.map(p => ({
                value: p,
                label: p
              }));
            }
            else if (field.key.toLowerCase() === 'bussinesstype') {
              options = this.businessTypeList.map(b => ({
                value: b,
                label: b
              }));
            }
            else if (field.key.toLowerCase() === 'reporttype') {
              options = this.misReportType.map(m => ({
                value: m.value,
                label: m.name
              }));
            }
            else if (field.key.toLowerCase() === 'deliveryreportstatus') {
              options = this.deliveryReportStatus.map(d => ({
                value: d.value,
                label: d.name
              }));
            }
            else if (field.key.toLowerCase() === 'locktype') {
              options = this.lockType.map(l => ({
                value: l.value,
                label: l.name
              }));
            }
            else if (field.key.toLowerCase() === 'customertype') {
              options = this.customerTypeList.map(c => ({
                value: c,
                label: c
              }));
            }

            const selectedValue = field.value || null;
            this.reportForm.addControl(field.key, new FormControl(selectedValue));
            field.options = options;
          } else {
            this.reportForm.addControl(field.key, new FormControl(field.value));
          }
        }
      } else {
        if (field.hasOwnProperty('origin')) {
          this.countryForm.get('ddlOriginCountry').setValue(field.origin.Country);
          this.bindStatesByCountry(field.origin.Country, 'origin');

          this.countryForm.get('ddlOriginState').setValue(field.origin.State);
          this.bindCitiesByState(field.origin.City, 'origin')

          this.onStateChange('origin');
          this.countryForm.get('ddlOriginCity').setValue(field.origin.City);
        }

        if (field.hasOwnProperty('destination')) {
          this.countryForm.get('ddlDestinationCountry').setValue(field.destination.Country);
          this.bindStatesByCountry(field.destination.Country);


          this.countryForm.get('ddlDestinationState').setValue(field.destination.State);
          this.bindCitiesByState(field.destination.City);

          this.onStateChange();
          this.countryForm.get('ddlDestinationCity').setValue(field.destination.City);
        }



      }

    });

    this.reportname = data[0].reportname;
    this.getReportDetails();
  }

  getReportDetails() {
    const formValues = this.reportForm.value;
    this.isFormSubmitted = true;
    const fromdate = new Date(formValues['From Date']);
    const todate = new Date(formValues['To Date']);
    const maxToDate = new Date(fromdate);
    maxToDate.setMonth(maxToDate.getMonth() + 6);

    if (fromdate > todate) {
      this.showWarningNotification('To Date should be greater than From Date');
      return;
    }

    if (todate > maxToDate) {
      this.openWarningMessageDialog('ToDate should not exceed 6 months from FromDate.');
      return;
    }

    if (this.reportForm.valid) {
      //for filtering in this report null value is required
      this.rowData = [];
      const reqObj = {
        reportType: this.reportname,
        fromdate: formValues['From Date'],
        todate: formValues['To Date'],
        customer: formValues['Customer'] || null,
        vendor: formValues['Vendor'] || null,
        productType: formValues['ProductType'] || null,
        originCountry: this.countryForm.get('ddlOriginCountry').value || null,
        originState: this.countryForm.get('ddlOriginState').value || null,
        originCity: this.countryForm.get('ddlOriginCity').value || null,
        destinationCountry: this.countryForm.get('ddlDestinationCountry').value || null,
        destinationState: this.countryForm.get('ddlDestinationState').value || null,
        destinationCity: this.countryForm.get('ddlDestinationCity').value || null,
        product: formValues['Product'] || null,
        servicecenter: formValues['ServiceCenter'] || null,
        salesexecutive: formValues['SalesExecutive'] || null,
        customertype: formValues['CustomerType'] || null,
        bussinesstype: formValues['BussinessType'] || null,
        misreporttype: formValues['ReportType'] || null,
        forwardingvendor: formValues['ForwardingVendor'] || null,
        deliveryStatus: formValues['DeliveryStatus'] || null,
        company: formValues['Company'] || null,
        paymentType: formValues['PaymentType'] || null,
        awbnumber: formValues['AwbNumber'] || null,
        lockType: formValues['LockType'] || null,
      }

      this.ngxLoadService.start();

      this.reportService.GetAll(reqObj).subscribe((res) => {
        if (res && res.success) {
          if (res.data?.length) {
            this.ngxLoadService.stop();
            this.rowData = [...res.data];
            this.reservedRowData = [...res.data];
            if (this.rowData.length > 0) {
              this.groupedColumns = Object.keys(this.rowData[0]);
              // Get column definitions
              this.columnDefs = Object.keys(this.rowData[0]).map((key, index) => ({
                headerName: key
                  .split('_')
                  .map((word, index) =>
                    index === 0
                      ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' '),
                field: key,
                hide: false,
                cellRenderer: index === 0 ? this.groupCellRenderer.bind(this) : undefined,
                cellStyle: index === 0 ? this.getGroupCellStyle.bind(this) : undefined,
                width: index === 0 ? 250 : undefined // Give more width to first column
              }));

              // // Group the data by first column
              // // const firstColumnField = Object.keys(this.rowData[0])[0];
              // this.groupedData = this.groupByColumn(this.rowData, this.currentGroup);
              
              // // Set initial state with all groups expanded
              // this.groupedData = this.groupedData.map(group => ({
              //   ...group,
              //   expanded: true // Start with all groups expanded
              // }));
              
              // // Flatten grouped data for initial display
              // this.rowData = this.flattenGroupedData(this.groupedData);
              
              // Update grid with new data
              // this.gridApi.setRowData(this.rowData);
            }
          } else {
            this.ngxLoadService.stop();
            this.rowData = [];
            this.columnDefs = [];
            this.gridApi.setRowData([]);
            this.gridApi.setColumnDefs([]);
            this.showInfoNotification('No Data found!');
          }
        } else if (res && !res.success) {
          this.ngxLoadService.stop();
          this.showInfoNotification(res.message);
        }
      });
      this.ngxLoadService.stop();
    }
  }

  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  calculateGroupTotals(children: any[]): any {
    const totals = {};
    if (children.length === 0) return totals;

    // Get all numeric column keys
    const numericColumns = Object.keys(children[0]).filter(key => {
      return this.isNumeric(children[0][key]);
    });

    // Calculate totals for numeric columns
    numericColumns.forEach(column => {
      totals[column] = children.reduce((sum, row) => {
        return sum + (parseFloat(row[column]) || 0);
      }, 0);
    });

    return totals;
  }

  groupByColumn(data: any[], field: string) {
    const groups = {};
    data.forEach(item => {
      const rawValue = item[field];
      // Handle null, undefined, empty string values
      const groupValue = rawValue === null || rawValue === undefined || rawValue === '' ? '(Blank)' : rawValue;
      
      if (!groups[groupValue]) {
        groups[groupValue] = {
          groupKey: groupValue,
          isGroup: true,
          expanded: false,
          children: []
        };
      }
      groups[groupValue].children.push(item);
    });

    // Calculate totals for each group
    Object.values(groups).forEach((group: any) => {
      group['totals'] = this.calculateGroupTotals(group.children);
    });

    return Object.values(groups);
  }

  calculateGrandTotal(groupedData: any[]): any {
    const grandTotal = {};
    
    // Get all numeric columns from the first group's totals
    if (groupedData.length > 0) {
      const numericColumns = Object.keys(groupedData[0].totals || {});
      
      numericColumns.forEach(column => {
        grandTotal[column] = groupedData.reduce((sum, group) => {
          return sum + (parseFloat(group.totals[column]) || 0);
        }, 0);
      });
    }
    
    return grandTotal;
  }

  flattenGroupedData(groupedData: any[]): any[] {
    const flattened = [];
    const firstColumnKey = this.groupedColumns[0];

    groupedData.forEach(group => {
      // Add group row
      flattened.push({
        [firstColumnKey]: group.groupKey,
        isGroup: true,
        expanded: group.expanded,
        groupKey: group.groupKey
      });

      // Add child rows when expanded
      if (group.expanded) {
        group.children.forEach(child => {
          flattened.push({...child, isGroupChild: true});
        });

        // Add total row after children
        const totalRow = {
          [firstColumnKey]: 'Total',
          isTotal: true,
          isGroupChild: true
        };

        // Add totals for numeric columns
        Object.entries(group.totals).forEach(([column, total]) => {
          totalRow[column] = total as string;
        });

        flattened.push(totalRow);
      }
    });

    // Add Grand Total row at the bottom
    if (groupedData.length > 0) {
      const grandTotalRow = {
        [firstColumnKey]: 'Grand Total',
        isGrandTotal: true
      };

      // Calculate and add grand totals for numeric columns
      const grandTotals = this.calculateGrandTotal(groupedData);
      Object.entries(grandTotals).forEach(([column, total]) => {
        grandTotalRow[column] = total as string;
      });

      flattened.push(grandTotalRow);
    }

    return flattened;
  }

  groupCellRenderer(params: any) {
    if (params.data.isGroup) {
      const expandIcon = params.data.expanded ? 'fa-chevron-circle-down' : 'fa-chevron-circle-right';
      const displayValue = params.value || '(Blank)';
      return `
        <div style="display:flex; align-items:center; column-gap:5px">
          <i class="fa ${expandIcon}"></i>
          <strong>${displayValue}</strong>
          <span style="color:#666;">(${this.getGroupChildCount(params.value)})</span>
        </div>`;
    }
    if (params.data.isTotal || params.data.isGrandTotal) {
      return `<strong style="margin-left:20px">${params.value}</strong>`;
    }
    return `<span style="margin-left:20px">${params.value || '(Blank)'}</span>`;
  }

  getGroupChildCount(groupKey: string): number {
    const group = this.groupedData.find(g => g.groupKey === groupKey);
    return group ? group.children.length : 0;
  }

  getGroupCellStyle(params: any) {
    if (params.data.isGroup) {
      return { 
        'background-color': '#f5f5f5',
        'font-weight': 'bold',
        'cursor': 'pointer',
        'border-bottom': '1px solid #ddd'
      };
    }
    if (params.data.isTotal) {
      return {
        'background-color': '#f9f9f9',
        'font-weight': 'bold',
        'border-top': '1px solid #ddd',
        'border-bottom': '1px solid #ddd'
      };
    }
    if (params.data.isGrandTotal) {
      return {
        'background-color': '#e9ecef',
        'font-weight': 'bold',
        'border-top': '2px solid #ddd',
        'border-bottom': '2px solid #ddd'
      };
    }
    if (params.data.isGroupChild) {
      return { 
        'background-color': '#ffffff',
      };
    }
    return {};
  }

  bindVendor() {
    this.vendorService.GetAll('').subscribe((res) => {
      this.vendorList = res?.success ? res.data : [];
    })
  }
  bindProducts() {
    try {
      this.productService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.productList = res.data;
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  bindCompanies() {
    try {
      this.companyService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.companyList = res.data;
          // const defaultCompanyObj = this.companyList.filter(x => x.isdefault === true);
          // this.reportForm.get('ddlCompanies').setValue(defaultCompanyObj);    
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  bindCustomers(sc) {
    try {
      this.customerService.GetAll({ scid: sc }).subscribe((res) => {
        if (res && res.success) {
          if (this.userType == 'Customer') {
            this.customerList = res.data.filter(x => x.id == this.defaultCustomer);
          }
          else {
            this.customerList = res.data;
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
  getServiceCenters() {
    try {
      this.networkService.GetAllServiceCenters().subscribe((res) => {
        if (res && res.success) {
          this.serviceCenterList = res.data;
          // bind default service center
          // this.manifestForm.get('ddlBranch').setValue(this.userServiceCenter.default)
        }
      })
    } catch (error) {

    }
  }
  showWarningNotification(msg: any) {
    this.toastr.warning(msg, 'Warning');
  }
  convertToDateFormat(dateString: string): string {
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  }

  async openConfirmationDialog(msg: any) {
    const res = await Swal.fire({
      // title: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (res.isConfirmed) {
      this.router.navigate(['/reports'])
    }
  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  exportExcel() {
    if (this.rowData.length) {
      let exportData = this.rowData.map(item => {
        const cleanedItem = {...item};
        delete cleanedItem.isGroup;
        delete cleanedItem.expanded;
        delete cleanedItem.groupKey;
        delete cleanedItem.isGroupChild; 
        delete cleanedItem.isTotal;
        return cleanedItem;
      });
      //let reportName = this.typeOptions.filter(x => x.id == this.reportNewForm.get('ddlType').value)[0].name;
      
      let reportName = this.reportname.replace(' ', '_');
      this.excelService.exportAsExcelFile(this.formatData(exportData), reportName);
    }
    else {
      this.showInfoNotification("No data to export");
    }
  }

  formatData(data: any) {
    let reports: any[] = [];
    reports = data;
    return reports;
  }

  showInfoNotification(msg: any) {
    this.toastr.info(msg, 'Info');
  }

  openWarningMessageDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK'
    })
  }



  addReport(): void {
    this.isFormSubmitted = true;
    const formValues = this.reportForm.value;
    if (this.reportNewForm.valid && this.permConfig.isAddAllowed) {

      this.fields.forEach(field => {
        if (field.key in formValues) {
          field.value = formValues[field.key];
          if (Array.isArray(field.options)) {
            delete field.options;
          }
        }
      });

      let destination = {
        City: this.countryForm.get('ddlDestinationCity').value || null,
        State: this.countryForm.get('ddlDestinationState').value || null,
        Country: this.countryForm.get('ddlDestinationCountry').value || null
      }

      let origin = {
        City: this.countryForm.get('ddlOriginCity').value || null,
        State: this.countryForm.get('ddlOriginState').value || null,
        Country: this.countryForm.get('ddlOriginCountry').value || null
      }

      this.fields.push({
        destination
      });
      this.fields.push({
        origin
      });

      let reqObj = {
        reporttypeid: this.reportData.reporttypeid,
        reportname: this.reportData.reportname,
        customreportname: this.reportNewForm.get('txtReportName').value,
        reporttitle: this.reportData.reporttitle,
        reportconfig: this.fields
      }

      this.reportService.Add(reqObj).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.openConfirmationDialog('Report Added successfully');
          this.hide(); 
          this.hide();
          //this.appCoreService.showMessage('Record Added successfully', 'Success', 'success');
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
          const message = res.message.includes('Http failure') ? 'Internal Server Error' : res.message;
          this.appCoreService.showMessage(message, 'Error', 'error');
        }
      })
    }
  }

  onCountryChange(origin?) {
    let countryCode: any;
    if (origin) {
      countryCode = this.countryForm.get('ddlOriginCountry').value;
      this.countryForm.controls.ddlOriginState.reset();
      this.countryForm.controls.ddlOriginCity.reset();
      this.originCityList = [];
      this.bindStatesByCountry(countryCode, origin);
      //this.allAWBList = this.allAWBList?.filter(x => (countryCode || x.origincountry === countryCode));
    }
    else {
      countryCode = this.countryForm.get('ddlDestinationCountry').value;
      this.countryForm.controls.ddlDestinationState.reset();
      this.countryForm.controls.ddlDestinationCity.reset();
      this.destinationCityList = [];
      this.bindStatesByCountry(countryCode);
      //this.allAWBList = this.allAWBList?.filter(x => (countryCode || x.destinationcountry === countryCode));
    }
  }

  bindCountries() {
    try {
      this.geoService.GetAllCountries().subscribe((res) => {
        if (res && res.success) {
          this.countryList = res.data;
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  bindStatesByCountry(countryCode?: string, type?: any) {
    try {
      if (countryCode) {
        this.geoService.GetAllStates({ countrycode: countryCode }).subscribe((res) => {
          if (res && res.success) {
            this.countryCode = countryCode;
            this[type === 'origin' ? 'originStateList' : 'destinationStateList'] = res.data;
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  onStateChange(origin?) {
    let countryCode: any;
    if (origin) {
      countryCode = this.countryForm.get('ddlOriginState').value;
      this.countryForm.controls.ddlOriginCity.reset();
      this.bindCitiesByState(countryCode, origin);
    }
    else {
      countryCode = this.countryForm.get('ddlDestinationState').value;
      this.countryForm.controls.ddlDestinationCity.reset();
      this.bindCitiesByState(countryCode);
    }
  }

  bindCitiesByState(stateCode?: string, type?: any) {
    try {
      if (stateCode) {
        this.geoService.GetAllCities({ statecode: stateCode }).subscribe((res) => {
          if (res && res.success) {
            this[type === 'origin' ? 'originCityList' : 'destinationCityList'] = res.data;
          }
        });
      }

    } catch (e) {
      console.error(e);
    }
  }

  saveSchedule() {
    if (this.scheduleForm.valid) {
      const formValues = this.reportForm.value;
      const reqObj = {
        reportType: this.reportname,
        fromdate: formValues['From Date'],
        todate: formValues['To Date'],
        customer: formValues['Customer'] || null,
        vendor: formValues['Vendor'] || null,
        productType: formValues['ProductType'] || null,
        originCountry: this.countryForm.get('ddlOriginCountry').value || null,
        originState: this.countryForm.get('ddlOriginState').value || null,
        originCity: this.countryForm.get('ddlOriginCity').value || null,
        destinationCountry: this.countryForm.get('ddlDestinationCountry').value || null,
        destinationState: this.countryForm.get('ddlDestinationState').value || null,
        destinationCity: this.countryForm.get('ddlDestinationCity').value || null,
        product: formValues['Product'] || null,
        servicecenter: formValues['ServiceCenter'] || null,
        salesexecutive: formValues['SalesExecutive'] || null,
        customertype: formValues['CustomerType'] || null,
        bussinesstype: formValues['BussinessType'] || null,
        misreporttype: formValues['ReportType'] || null,
        forwardingvendor: formValues['ForwardingVendor'] || null,
        deliveryStatus: formValues['DeliveryStatus'] || null,
        company: formValues['Company'] || null,
        paymentType: formValues['PaymentType'] || null,
        awbnumber: formValues['AwbNumber'] || null,
        lockType: formValues['LockType'] || null,
      }

      let targetType = this.scheduleForm.value.targetType;
      const scheduleData = {
        id: this.schdulerId,
        scheduletype: 'Report',
        referenceid: this.reportId,
        schedulefrequency: this.scheduleForm.value.frequency,
        isactive: this.scheduleForm.value.active,
        schedulemetadata: {
          emailIds: targetType != 'Customer' ? this.scheduleForm.value.emailIds : null,
          targettype: this.scheduleForm.value.targetType,
          filters: JSON.stringify(reqObj)
        }
      };

      this.ngxLoadService.start();
      this.reportService.ScheduleReport(scheduleData).subscribe(
        (res: any) => {
          this.ngxLoadService.stop();
          if(res){
            if (res.success) {
              this.toastr.success('Report scheduled successfully', 'Success');
              // this.scheduleForm.reset({active: true});
            } else {
              this.toastr.error(res.message || 'Failed to schedule report', 'Error');
            }
          }
        },
        (error) => {
          this.ngxLoadService.stop();
          this.toastr.error('Failed to schedule report', 'Error');
          console.error('Schedule error:', error);
        }
      );
    } else {
      this.toastr.warning('Please fill all required fields', 'Warning');
    }
  }

  groupRowData(fieldtogroup?: string){
    // Group the data by first column
    // const firstColumnField = Object.keys(this.rowData[0])[0];
    // fieldtogroup = !fieldtogroup ? Object.keys(this.rowData[0])[0] : fieldtogroup;
    if(fieldtogroup){
      this.groupedData = [];
      this.groupedData = this.groupByColumn(this.reservedRowData, fieldtogroup);
      
      // Set initial state with all groups expanded
      this.groupedData = this.groupedData.map(group => ({
        ...group,
        expanded: true // Start with all groups expanded
      }));
      
      // Flatten grouped data for initial display
      // this.rowData = [];
      this.rowData = this.flattenGroupedData(this.groupedData);
  
      // Reset grid state and update with new data
      this.gridApi.setRowData(this.rowData);
    } else {
      // Reset grid state and update with new data
      this.gridApi.setRowData(this.reservedRowData);
    }
  }

  onGroupChange() {
    this.groupRowData(this.currentGroup);
  }

  openReportModal(){
    if (this.reportData.customreportname == null) {
      this.isShowCustomReportName = true;
      this.isModalOpen = true;
    }
  }

  hide() {
    //document.body.classList.remove('right-bar-enabled');
    this.isModalOpen = false;    
  }
}